import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import offerModalReducer from '../reducers/offerModalReducer';

const configureStore = (railsProps) => (
  createStore(offerModalReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
